import { render, staticRenderFns } from "./pwd-change.vue?vue&type=template&id=7c0ef24e&"
import script from "./pwd-change.vue?vue&type=script&lang=js&"
export * from "./pwd-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports